/* ==========================================================================
   MY QAMIS HOMME - Panier

   1. Ouvre le tiroir apres l'ajout d'une box (/?panier=ouvert)
   2. Retire les options dont le produit parent a ete supprime

   Le verrouillage visuel des lignes d'options est gere en Liquid dans
   snippets/cart-products.liquid : plus fiable, car cote serveur.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__mqhCartBox) return;
  window.__mqhCartBox = true;

  var enCours = false;

  /* ---------- ouverture du tiroir ---------- */

  function demandeOuverture() {
    try {
      return new URLSearchParams(window.location.search).get('panier') === 'ouvert';
    } catch (e) {
      return window.location.search.indexOf('panier=ouvert') !== -1;
    }
  }

  function nettoyerUrl() {
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('panier');
      history.replaceState(null, '', url.pathname + url.search + url.hash);
    } catch (e) {}
  }

  function ouvrir(drawer) {
    if (typeof drawer.open === 'function') { drawer.open(); return true; }
    if (typeof drawer.showDialog === 'function') { drawer.showDialog(); return true; }
    var dlg = drawer.querySelector('dialog');
    if (dlg && typeof dlg.showModal === 'function') { dlg.showModal(); return true; }
    var bouton = drawer.querySelector('[data-testid="cart-drawer-trigger"]') || drawer.querySelector('button');
    if (bouton) { bouton.click(); return true; }
    return false;
  }

  function essayerOuvrir(tentative) {
    tentative = tentative || 0;
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && ouvrir(drawer)) { nettoyerUrl(); return; }
    if (tentative < 30) {
      setTimeout(function () { essayerOuvrir(tentative + 1); }, 120);
      return;
    }
    nettoyerUrl();
  }

  /* ---------- nettoyage des options orphelines ---------- */

  function trouverOrphelines(cart) {
    var parents = {};
    var items = cart.items || [];

    for (var i = 0; i < items.length; i++) {
      var ligne = items[i].properties && items[i].properties._box_ligne;
      if (ligne) parents[ligne] = true;
    }

    var aRetirer = [];
    for (var j = 0; j < items.length; j++) {
      var pere = items[j].properties && items[j].properties._box_parent;
      if (pere && !parents[pere]) aRetirer.push(items[j].key);
    }
    return aRetirer;
  }

  function retirer(cles) {
    var suite = Promise.resolve();
    cles.forEach(function (cle) {
      suite = suite.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: cle, quantity: 0 })
        });
      });
    });
    return suite;
  }

  /* Redessine le panier sans recharger la page.
     Les noms de sections sont lus dans la page elle-meme
     (id="shopify-section-xxx"), jamais devines. */
  function sectionsDuPanier() {
    var trouvees = [];
    var hotes = document.querySelectorAll('cart-drawer-component, cart-items-component');

    for (var i = 0; i < hotes.length; i++) {
      var section = hotes[i].closest('[id^="shopify-section-"]');
      if (!section) continue;

      var nom = section.id.replace('shopify-section-', '');
      var deja = false;
      for (var j = 0; j < trouvees.length; j++) {
        if (trouvees[j].nom === nom) deja = true;
      }
      if (!deja) trouvees.push({ nom: nom, id: section.id });
    }
    return trouvees;
  }

  function rafraichir() {
    var sections = sectionsDuPanier();

    /* la page n'affiche pas le panier : rien a redessiner */
    if (!sections.length) {
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
      return Promise.resolve(true);
    }

    var noms = [];
    for (var i = 0; i < sections.length; i++) noms.push(sections[i].nom);

    return fetch('/?sections=' + encodeURIComponent(noms.join(',')), {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.json(); })
      .then(function (rendus) {
        var remplace = false;

        for (var i = 0; i < sections.length; i++) {
          var html = rendus[sections[i].nom];
          var hote = document.getElementById(sections[i].id);
          if (!html || !hote) continue;

          var doc = new DOMParser().parseFromString(html, 'text/html');
          var frais = doc.getElementById(sections[i].id) || doc.body.firstElementChild;
          if (!frais) continue;

          hote.innerHTML = frais.innerHTML;
          remplace = true;
        }

        if (remplace) {
          ['cart:update', 'cart:refresh'].forEach(function (nom) {
            document.dispatchEvent(new CustomEvent(nom, {
              bubbles: true,
              detail: { source: 'mqh-cart-box' }
            }));
          });
        }
        return remplace;
      })
      .catch(function () { return false; });
  }

  var dernierPassage = 0;

  function verifier() {
    if (enCours) return;
    /* le redessin modifie le DOM et reveille l'observateur :
       on laisse passer un court delai pour eviter les allers-retours */
    if (Date.now() - dernierPassage < 800) return;

    enCours = true;
    dernierPassage = Date.now();

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var orphelines = trouverOrphelines(cart);
        if (!orphelines.length) { enCours = false; return; }

        return retirer(orphelines)
          .then(rafraichir)
          .then(function (ok) {
            enCours = false;
            /* si le redessin a echoue, on recharge : mieux vaut un
               clignotement qu'un panier affichant des lignes disparues */
            if (!ok) window.location.reload();
          });
      })
      .catch(function () { enCours = false; });
  }

  /* ---------- vidage du panier ---------- */

  function brancherVidage() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mqh-cart-clear]');
      if (!btn) return;
      e.preventDefault();

      if (!window.confirm('Vider entierement votre panier ?')) return;

      btn.disabled = true;
      btn.textContent = 'Suppression...';

      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
      })
        .then(rafraichir)
        .then(function (ok) {
          if (!ok) window.location.reload();
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = 'Vider le panier';
        });
    });
  }

  /* ---------- demarrage ---------- */

  function demarrer() {
    verifier();
    brancherVidage();

    if (demandeOuverture()) {
      if (window.customElements && customElements.whenDefined) {
        customElements.whenDefined('cart-drawer-component')
          .then(function () { essayerOuvrir(0); })
          .catch(function () { essayerOuvrir(0); });
      }
      essayerOuvrir(0);
    }

    /* le panier de Horizon se redessine sans recharger la page */
    ['cart:update', 'cart:refresh', 'cart:change'].forEach(function (nom) {
      document.addEventListener(nom, function () { setTimeout(verifier, 400); });
    });

    var cible = document.querySelector('cart-drawer-component, cart-items-component, main');
    if (cible && window.MutationObserver) {
      var minuteur = null;
      new MutationObserver(function () {
        clearTimeout(minuteur);
        minuteur = setTimeout(verifier, 500);
      }).observe(cible, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();